import { apiRequest, postJSON } from "../queryClient";
import type { ConnectionStatus, NodeKind } from "./core";

export interface IncomingConnectionRequestDTO {
  id: string;
  orgId: string;
  orgName: string;
  createdAt: string;
}

export function getIncomingConnectionRequests(): Promise<{ requests: IncomingConnectionRequestDTO[] }> {
  return apiRequest("/api/connections/individual/incoming-pending");
}

export function acceptConnectionRequest(requestId: string): Promise<{ membership: { id: string; orgId: string } }> {
  return postJSON(`/api/connections/individual/${requestId}/accept`, {});
}

export function declineConnectionRequest(requestId: string): Promise<{ request: { id: string; status: string } }> {
  return postJSON(`/api/connections/individual/${requestId}/decline`, {});
}

export interface IncomingOrgConnectionRequestDTO {
  connectionId: string;
  initiatingOrgId: string;
  initiatingOrgName: string;
  targetOrgId: string;
  targetOrgName: string;
  targetKind: NodeKind;
  createdAt: string;
}

export interface OrgConnectionDecisionDTO {
  id: string;
  initiatingOrgId: string;
  targetOrgId: string;
  status: ConnectionStatus;
  createdAt: string;
  acceptedAt: string | null;
  certificateId: string | null;
  removedAt: string | null;
  removedByOrgId: string | null;
}

export interface OrgConnectionDecisionResponse {
  connection: OrgConnectionDecisionDTO;
  certificateId?: string;
}

export function getIncomingOrgConnectionRequests(): Promise<{ requests: IncomingOrgConnectionRequestDTO[] }> {
  return apiRequest<{ requests: IncomingOrgConnectionRequestDTO[] }>("/api/connections/incoming-pending");
}

export function acceptOrgConnectionRequest(connectionId: string): Promise<OrgConnectionDecisionResponse> {
  return postJSON<OrgConnectionDecisionResponse>(`/api/connections/${encodeURIComponent(connectionId)}/accept`, {});
}

export function declineOrgConnectionRequest(connectionId: string): Promise<OrgConnectionDecisionResponse> {
  return postJSON<OrgConnectionDecisionResponse>(`/api/connections/${encodeURIComponent(connectionId)}/decline`, {});
}
